import { z } from 'zod';

export const EmployeeOtherFilter = z.object({
  // null: no condition, false: not applicable, true: applicable
  isOnSecondment: z.boolean().nullable().default(null),
  isLeave: z.boolean().nullable().default(null),
});
export type EmployeeOtherFilterType = z.infer<typeof EmployeeOtherFilter>;
